import * as React from "react";
import { Box, Container, Stack } from "@mui/material";

export function ResponsiveStack({
                                    children,
                                    maxWidth = "100%",
                                    spacing = {xs: 3, sm: 3, md: 3, lg: 3, xl: 3},
                                    rowSpacing = spacing,
                                    columnSpacing = spacing,
                                    sx,
                                    containerProps,
                                    stackProps,
                                    columns = { xs: 1, sm: 2, md: 2, lg: 3, xl: 3 },
                                    justifyContent = "center",
                                    alignItems = "stretch",
                                    itemMaxWidth,
                                    itemHeight,
                                }) {
    const childArray = React.Children.toArray(children);

    const itemBasis = {
        xs: `${100 / (columns.xs || 1)}%`,
        sm: `${100 / (columns.sm || columns.xs || 1)}%`,
        md: `${100 / (columns.md || columns.sm || columns.xs || 1)}%`,
        lg: `${100 / (columns.lg || columns.md || columns.sm || columns.xs || 1)}%`,
        xl: `${100 / (columns.xl || columns.lg || columns.md || columns.sm || columns.xs || 1)}%`,
    };

    return (
        <Container
            maxWidth={maxWidth}
            sx={{...sx }}
            {...containerProps}
        >
            <Stack
                direction="row"
                flexWrap="wrap"
                useFlexGap
                justifyContent={justifyContent}
                alignItems={alignItems}
                {...stackProps}
                sx={{
                    rowGap: rowSpacing,
                    columnGap: columnSpacing,
                    ...(stackProps?.sx || {}),
                }}
            >
                {childArray.map((child, idx) => (
                    <Box
                        key={child?.key ?? idx}
                        sx={{
                            flexGrow: 0,
                            flexShrink: 0,
                            flexBasis: itemBasis,
                            minWidth: 0,
                            maxWidth: itemMaxWidth || "100%",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                maxWidth: itemMaxWidth || "100%",
                                height: itemHeight || "auto",
                            }}
                        >
                            {child}
                        </Box>
                    </Box>
                ))}
            </Stack>
        </Container>
    );
}
